import { AsyncActionHandler } from 'action-handler';
import { fetchHasSettings } from 'action-utils';

export default new AsyncActionHandler({
  name: 'fetch_many_has_settings',
  handler: () => async (_, getState) => {
    const state = getState();
    const {
      installed: { entries = [] }
    } = state.registry;

    return {
      settings: await fetchHasSettings(
        entries.map(({ appId }) => appId),
        state
      )
    };
  },
  reduce(state, { settings }) {
    return {
      settings: {
        ...state.settings,
        ...settings
      }
    };
  }
});
